/**
 * Global Search Data Index
 * Centralized searchable navigation items including sidebar and tab navigation entries
 */

export const searchableItems = [
    // ==================== MAIN NAVIGATION ====================
    {
        id: "nav-dashboard",
        title: "Dashboard",
        route: "/admin",
        category: "Main Navigation",
        parent: null,
        keywords: ["home", "overview", "main"],
        type: "page",
        description: "Your main dashboard overview",
        icon: "Dashboard"
    },
    {
        id: "nav-policies",
        title: "Policies",
        route: "/admin/policies",
        category: "Main Navigation",
        parent: null,
        keywords: ["insurance", "coverage", "plans"],
        type: "page",
        description: "Manage your insurance policies",
        icon: "Description"
    },
    {
        id: "nav-savings",
        title: "Savings",
        route: "/admin/savings",
        category: "Main Navigation",
        parent: null,
        keywords: ["money", "save", "investment"],
        type: "page",
        description: "Track your savings plans",
        icon: "Savings"
    },
    {
        id: "nav-claims",
        title: "Claims",
        route: "/admin/claims",
        category: "Main Navigation",
        parent: null,
        keywords: ["file", "submit", "insurance claim"],
        type: "page",
        description: "File and track insurance claims",
        icon: "Assignment"
    },
    {
        id: "nav-rewards",
        title: "Rewards",
        route: "/admin/rewards",
        category: "Main Navigation",
        parent: null,
        keywords: ["points", "vouchers", "earnings", "coins"],
        type: "page",
        description: "Earn rewards and redeem vouchers",
        icon: "CardGiftcard"
    },
    {
        id: "nav-rewards-learn-earn",
        title: "Learn & Earn",
        route: "/admin/learn-earn",
        category: "Main Navigation",
        parent: null,
        keywords: ["education", "training", "courses", "rewards"],
        type: "page",
        description: "Complete courses and earn rewards",
        icon: "CardGiftcard"
    },
    {
        id: "nav-give-back",
        title: "Give Back",
        route: "/admin/give-back",
        category: "Main Navigation",
        parent: null,
        keywords: ["donate", "charity", "ngo", "donation"],
        type: "page",
        description: "Donate to charities and NGOs",
        icon: "Favorite"
    },
    {
        id: "nav-invite-friends",
        title: "Invite Friends",
        route: "/admin/invite-friends",
        category: "Main Navigation",
        parent: null,
        keywords: ["referral", "share", "refer"],
        type: "page",
        description: "Invite friends and earn rewards",
        icon: "PersonAdd"
    },
    {
        id: "nav-services",
        title: "Services",
        route: "/admin/subscriptions",
        category: "Main Navigation",
        parent: null,
        keywords: ["tools", "utilities", "features"],
        type: "page",
        description: "Access additional services",
        icon: "Build"
    },
    {
        id: "nav-requests",
        title: "Requests",
        route: "/admin/requests",
        category: "Main Navigation",
        parent: null,
        keywords: ["pending", "submitted", "application"],
        type: "page",
        description: "View your service requests",
        icon: "RequestPage"
    },

    // ==================== BOTTOM NAVIGATION ====================
    {
        id: "nav-help-center",
        title: "Help Center",
        route: "/admin/help-center",
        category: "Support",
        parent: null,
        keywords: ["support", "help", "chat", "contact"],
        type: "page",
        description: "Get help and support",
        icon: "HelpCenter"
    },
    {
        id: "nav-settings",
        title: "Settings",
        route: "/admin/settings",
        category: "Support",
        parent: null,
        keywords: ["preferences", "account", "profile"],
        type: "page",
        description: "Manage your account settings",
        icon: "Settings"
    },

    // ==================== POLICIES TAB NAVIGATION ====================
    {
        id: "policies-tab-active",
        title: "Active Policies",
        route: "/admin/policies",
        category: "Policies",
        parent: "Policies",
        keywords: ["current", "ongoing", "active insurance"],
        type: "tab",
        description: "View your active policies",
        tabName: "Active"
    },
    {
        id: "policies-tab-inactive",
        title: "Inactive Policies",
        route: "/admin/policies",
        category: "Policies",
        parent: "Policies",
        keywords: ["expired", "stopped", "paused"],
        type: "tab",
        description: "View inactive policies",
        tabName: "Inactive"
    },
    {
        id: "policies-tab-cancelled",
        title: "Cancelled Policies",
        route: "/admin/policies",
        category: "Policies",
        parent: "Policies",
        keywords: ["terminated", "cancelled insurance"],
        type: "tab",
        description: "View cancelled policies",
        tabName: "Cancelled"
    },

    // ==================== CLAIMS TAB NAVIGATION ====================
    {
        id: "claims-tab-new",
        title: "New Claims",
        route: "/admin/claims",
        category: "Claims",
        parent: "Claims",
        keywords: ["file", "submit", "new claim", "create"],
        type: "tab",
        description: "File a new claim",
        tabName: "New"
    },
    {
        id: "claims-tab-track",
        title: "Track Claims",
        route: "/admin/claims",
        category: "Claims",
        parent: "Claims",
        keywords: ["status", "track", "monitor", "view claims"],
        type: "tab",
        description: "Track your existing claims",
        tabName: "Track"
    },

    // ==================== POLICY DETAILS TAB NAVIGATION ====================
    // {
    //     id: "policy-details-tab-overview",
    //     title: "Policy Overview",
    //     route: "/admin/policies/:id",
    //     category: "Policy Details",
    //     parent: "Policies",
    //     keywords: ["summary", "details", "information"],
    //     type: "tab",
    //     description: "Policy summary and overview",
    //     tabName: "Overview"
    // },
    // {
    //     id: "policy-details-tab-details",
    //     title: "Policy Details",
    //     route: "/admin/policies/:id",
    //     category: "Policy Details",
    //     parent: "Policies",
    //     keywords: ["full details", "specifications"],
    //     type: "tab",
    //     description: "Complete policy details",
    //     tabName: "Details"
    // },
    // {
    //     id: "policy-details-tab-coverage",
    //     title: "What's Covered",
    //     route: "/admin/policies/:id",
    //     category: "Policy Details",
    //     parent: "Policies",
    //     keywords: ["coverage", "benefits", "included"],
    //     type: "tab",
    //     description: "View policy coverage",
    //     tabName: "What's covered"
    // },
    // {
    //     id: "policy-details-tab-payments",
    //     title: "Policy Payments",
    //     route: "/admin/policies/:id",
    //     category: "Policy Details",
    //     parent: "Policies",
    //     keywords: ["billing", "payment history", "transactions"],
    //     type: "tab",
    //     description: "View payment history",
    //     tabName: "Payments"
    // },

    // ==================== SAVINGS TAB NAVIGATION ====================
    {
        id: "savings-tab-active",
        title: "Active Savings",
        route: "/admin/savings",
        category: "Savings",
        parent: "Savings",
        keywords: ["current", "ongoing savings"],
        type: "tab",
        description: "View active savings plans",
        tabName: "Active"
    },
    {
        id: "savings-tab-completed",
        title: "Completed Savings",
        route: "/admin/savings",
        category: "Savings",
        parent: "Savings",
        keywords: ["finished", "matured"],
        type: "tab",
        description: "View completed savings plans",
        tabName: "Completed"
    },
    {
        id: "savings-tab-withdrawn",
        title: "Withdrawn Savings",
        route: "/admin/savings",
        category: "Savings",
        parent: "Savings",
        keywords: ["closed", "withdrawn"],
        type: "tab",
        description: "View withdrawn savings",
        tabName: "Withdrawn"
    },

    // ==================== SAVINGS DETAILS TAB NAVIGATION ====================
    // {
    //     id: "savings-details-tab-overview",
    //     title: "Savings Overview",
    //     route: "/admin/savings/:id",
    //     category: "Savings Details",
    //     parent: "Savings",
    //     keywords: ["summary", "savings info"],
    //     type: "tab",
    //     description: "Savings plan overview",
    //     tabName: "Overview"
    // },
    // {
    //     id: "savings-details-tab-details",
    //     title: "Savings Details",
    //     route: "/admin/savings/:id",
    //     category: "Savings Details",
    //     parent: "Savings",
    //     keywords: ["full details", "specifications"],
    //     type: "tab",
    //     description: "Complete savings details",
    //     tabName: "Details"
    // },
    // {
    //     id: "savings-details-tab-coverage",
    //     title: "Savings Coverage",
    //     route: "/admin/savings/:id",
    //     category: "Savings Details",
    //     parent: "Savings",
    //     keywords: ["coverage", "benefits"],
    //     type: "tab",
    //     description: "View savings coverage",
    //     tabName: "Coverage"
    // },

    // ==================== SAVINGS PAYMENT TAB NAVIGATION ====================
    // {
    //     id: "savings-payment-tab-linked",
    //     title: "Linked Payment Methods",
    //     route: "/admin/savings/payment",
    //     category: "Savings Payment",
    //     parent: "Savings",
    //     keywords: ["saved", "connected", "payment methods"],
    //     type: "tab",
    //     description: "View linked payment methods",
    //     tabName: "Linked"
    // },
    // {
    //     id: "savings-payment-tab-add-new",
    //     title: "Add New Payment Method",
    //     route: "/admin/savings/payment",
    //     category: "Savings Payment",
    //     parent: "Savings",
    //     keywords: ["new card", "add payment"],
    //     type: "tab",
    //     description: "Add new payment method",
    //     tabName: "Add New"
    // },

    // ==================== REWARDS TAB NAVIGATION ====================
    {
        id: "rewards-tab-vouchers",
        title: "My Vouchers",
        route: "/admin/rewards",
        category: "Rewards",
        parent: "Rewards",
        keywords: ["coupons", "vouchers", "discounts"],
        type: "tab",
        description: "View your vouchers",
        tabName: "My Vouchers"
    },
    {
        id: "rewards-tab-earnings",
        title: "My Earnings",
        route: "/admin/rewards",
        category: "Rewards",
        parent: "Rewards",
        keywords: ["coins", "points", "balance"],
        type: "tab",
        description: "View your earnings",
        tabName: "My Earnings"
    },
    {
        id: "rewards-tab-earn-more",
        title: "Earn More",
        route: "/admin/rewards",
        category: "Rewards",
        parent: "Rewards",
        keywords: ["tasks", "activities", "earn coins"],
        type: "tab",
        description: "Ways to earn more rewards",
        tabName: "Earn More"
    },
    {
        id: "rewards-tab-store",
        title: "Voucher Store",
        route: "/admin/rewards",
        category: "Rewards",
        parent: "Rewards",
        keywords: ["shop", "redeem", "buy vouchers"],
        type: "tab",
        description: "Redeem rewards for vouchers",
        tabName: "Voucher Store"
    },
    {
        id: "rewards-tab-faqs",
        title: "Rewards FAQs",
        route: "/admin/rewards",
        category: "Rewards",
        parent: "Rewards",
        keywords: ["help", "questions", "answers"],
        type: "tab",
        description: "Frequently asked questions",
        tabName: "FAQs"
    },

    // ==================== GIVE BACK TAB NAVIGATION ====================
    {
        id: "give-back-tab-donations",
        title: "My Donations",
        route: "/admin/give-back",
        category: "Give Back",
        parent: "Give Back",
        keywords: ["contributed", "charity history"],
        type: "tab",
        description: "View your donation history",
        tabName: "Donations"
    },
    {
        id: "give-back-tab-charities",
        title: "Charities",
        route: "/admin/give-back",
        category: "Give Back",
        parent: "Give Back",
        keywords: ["ngo", "organizations", "causes"],
        type: "tab",
        description: "Browse available charities",
        tabName: "Charities"
    },
    {
        id: "give-back-tab-faqs",
        title: "Give Back FAQs",
        route: "/admin/give-back",
        category: "Give Back",
        parent: "Give Back",
        keywords: ["help", "questions", "donation help"],
        type: "tab",
        description: "Donation FAQs",
        tabName: "FAQs"
    },

    // ==================== REQUESTS TAB NAVIGATION ====================
    {
        id: "requests-tab-pending",
        title: "Pending Requests",
        route: "/admin/requests",
        category: "Requests",
        parent: "Requests",
        keywords: ["waiting", "in progress", "processing"],
        type: "tab",
        description: "View pending requests",
        tabName: "Pending"
    },
    {
        id: "requests-tab-completed",
        title: "Completed Requests",
        route: "/admin/requests",
        category: "Requests",
        parent: "Requests",
        keywords: ["finished", "approved", "done"],
        type: "tab",
        description: "View completed requests",
        tabName: "Completed"
    },
    {
        id: "requests-tab-rejected",
        title: "Rejected Requests",
        route: "/admin/requests",
        category: "Requests",
        parent: "Requests",
        keywords: ["denied", "declined", "rejected"],
        type: "tab",
        description: "View rejected requests",
        tabName: "Rejected"
    },

    // ==================== SETTINGS TAB NAVIGATION ====================
    {
        id: "settings-tab-profile",
        title: "Profile Settings",
        route: "/admin/settings",
        category: "Settings",
        parent: "Settings",
        keywords: ["personal", "account", "info"],
        type: "tab",
        description: "Edit your profile",
        tabName: "Profile"
    },
    {
        id: "settings-tab-passwords",
        title: "Password Settings",
        route: "/admin/settings",
        category: "Settings",
        parent: "Settings",
        keywords: ["security", "change password", "reset"],
        type: "tab",
        description: "Change your password",
        tabName: "Passwords"
    },
];

// Export categories for grouping
export const searchCategories = [
    "Main Navigation",
    "Support",
    "Policies",
    "Policy Details",
    "Claims",
    "Savings",
    "Savings Details",
    "Savings Payment",
    "Rewards",
    "Give Back",
    "Requests",
    "Settings",
];
